import React from 'react';
import { injectIntl } from 'react-intl';

import { VerificationService,
         ActiveMilitaryPersonalInfoViewModel,
         VerificationStepsEnum,
         getMaxReviewTime,
         PoweredByComponent,
 } from '@sheerid/jslib';
import { LogoComponent } from '../LogoComponent/LogoComponent';
import { ReviewPendingComponent } from '../ReviewPendingComponent';
import { PrivacyPolicy } from '../PrivacyPolicy';

const DOC_UPLOAD_POLL_DURATION_DURING_COUNTDOWN = 5000;
const SSO_POLL_DURATION = 5000;

interface StepPendingProps {
    verificationService: VerificationService;
    intl: any;
}

const StepPending = ({ verificationService, intl }: StepPendingProps) => {
    const programId = verificationService.programId;
    const previousViewModel = (verificationService.previousViewModel as ActiveMilitaryPersonalInfoViewModel) || undefined;
    const previousVerificationResponse = verificationService.previousVerificationResponse || undefined;
    const verificationId = verificationService.verificationResponse.verificationId;
    const hasLogo = verificationService.programTheme.logoUrl ? true : false;

    const getLogo = () => (
        hasLogo ? (
            <LogoComponent verificationService={verificationService} />
        ) : (
            <img
                className="sid-l-lead-image"
                alt="design element"
                src="https://assets-resources.sheerid.com/common/images/2018/icons/doc-pending.svg"
            />
        )
    );

    const isPreviousStepSSO = (): boolean => {
        if (previousVerificationResponse && previousVerificationResponse.currentStep === VerificationStepsEnum.sso) {
            return true;
        }
        return false;
    };

    const pollForVerificationServiceUpdates = (timer: number) => setTimeout(
        () => {
            timerRef.current = pollForVerificationServiceUpdates(timer);
            verificationService.fetchExistingVerificationRequest(programId, verificationId, previousVerificationResponse, previousViewModel, false);
        },
        timer,
    );

    const timerRef = React.useRef(null);

    React.useEffect(() => {
        const timer = isPreviousStepSSO() ? SSO_POLL_DURATION : DOC_UPLOAD_POLL_DURATION_DURING_COUNTDOWN;
        timerRef.current = pollForVerificationServiceUpdates(timer);
        return () => clearTimeout(timerRef.current);
    });

    const logo = getLogo();

    return (
        <div id="sid-step-pending" className="sid-l-container" role="main">
                <ReviewPendingComponent logo={logo} intl={intl} maxReviewTime={getMaxReviewTime(verificationService.programTheme)} />
                <PoweredByComponent verificationService={verificationService} isCentered />
                <PrivacyPolicy />
        </div>
    );
};

export const StepPendingComponent = injectIntl(StepPending);
